<template>
  <PageTemplate>

    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          {{ $t('report_sick_days.title') }}
        </h6>
      </div>

      <div class="element-box">
        <h5 class="form-header mb-5">
          {{ $t('report_sick_days.user_list') }}
        </h5>

        <Search
            :filters="filters"
            :loading="isSearching"
            :officeDropdown="officeDropdown"
            :userDropdown="userDropdown"
            @search="getUsersList"/>

        <PerPage :values="[10, 25, 50, 100]" @update:perPage="getUsersList"/>

        <div class="table-responsive overflow-auto pt-5">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Mitarbeiternr</th>
              <th>Vorname</th>
              <th>Nachname</th>
              <th>Rechte</th>
              <th class="text-center">Offene Krankheitstage</th>
              <th style=" text-align: right; padding-right: 30px; min-width: 150px;">
                {{ $t('general.actions') }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(user) in users.data" :key="user.userId">
              <td>{{ user?.employeeNumber }}</td>
              <td>{{ user?.firstName }}</td>
              <td>{{ user?.lastName }}</td>
              <td>{{ user?.accessRightTranslated }}</td>
              <td class="text-center">
                  <span v-if="user?.numberOfPendingSickDays > 0"
                        style="background-color: orange;
                        color: white;
                        padding: 7px 10px;
                        border-radius: 50%;">
                      {{ user?.numberOfPendingSickDays }}
                  </span>
              </td>
              <td class="text-right">
                <button class="btn btn-primary" @click="router.push({
                name: 'monthlyOverviewForApproval', params: {year: data?.year, month: data?.month} })">
                  Übersicht
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <Pagination
            v-if="users?.pagination?.total_pages > 1"
            :totalPages="users?.pagination?.total_pages"
            :currentPage="users?.pagination?.current_page"
            @pagechanged="getUsersList"/>
      </div>
    </div>
  </PageTemplate>
</template>


<script setup>
import reportSickDaysService from '@/api/ReportSickDays';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import router from '@/router';
import { getOfficeDropdown, getUsersForHrOverviewDropdown } from '@/shared/dropdowns';
import Search from '@/views/App/ReportSickDays/V2/Search.vue';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t }   = useI18n();
const users   = ref([]);
const filters = ref({
  officeId: '',
  userId: '',
  orderBy: 'DESC',
  sortBy: '',
});

const isSearching    = ref(false);
const isLoaded       = ref(false);
const officeDropdown = ref([]);
const userDropdown   = ref([]);

async function getUsersList(page = 1, perPage, passedFilters) {
  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = users.value?.pagination?.items_per_page;

  try {
    const { data } = await reportSickDaysService.getUserListV2({
      page: page,
      limit: perPage ?? perPageRes,
      ...(passedFilters ? passedFilters : filters.value),
    });

    users.value       = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

onMounted(async () => {
  CloseToast();
  await Promise.all([
    getOfficeDropdown(officeDropdown, t),
    getUsersForHrOverviewDropdown(userDropdown),
    getUsersList(),
  ]);

  isLoaded.value = true;
});


</script>

<style scoped>

</style>